import { startOfMonth, endOfMonth } from 'date-fns';

export const fetchMonthlyPlanData = async (firebase, date) => {
  const startDate = startOfMonth(date);
  const endDate = endOfMonth(date);

  const flightsSnapshot = await firebase.flights()
    .where("takeoffTime", ">=", startDate.toISOString())
    .where("takeoffTime", "<=", endDate.toISOString())
    .get();

  const flights = [];
  flightsSnapshot.forEach(doc => {
    flights.push({ id: doc.id, ...doc.data() });
  });

  // Sort by takeoffTime
  flights.sort((a, b) => a.takeoffTime.localeCompare(b.takeoffTime));

  return flights;
};
